import { Injectable } from '@angular/core';
import { environment } from "@appEnv/environment";
import { Router } from "@angular/router";
import { AuthService } from '@app/service/auth.service';

@Injectable({
  providedIn: 'root'
})
export class VtSSOService {
  private ticketId: string | null = null;
  public static requestParamTicketKey = 'ticket';
  public static callbackUrlKey = 'callbackServiceUrl';

  constructor(private router: Router, private authService: AuthService) {
    this.loadTicketId();
  }

  loadTicketId() {
    const savedTicketId = localStorage.getItem(VtSSOService.requestParamTicketKey);
    if (savedTicketId) {
      this.ticketId = savedTicketId;
    } else {
      this.checkTicketIdAndRedirect()
    }
  }

  checkTicketIdAndRedirect() {
    const urlParams = new URLSearchParams(window.location.search);
    this.ticketId = urlParams.get(VtSSOService.requestParamTicketKey);
    if (!this.ticketId) {
      this.redirectCustomLogin();
    } else {
      this.router.navigate(['/validate-ticket'], { queryParams: { ticket: this.ticketId } }).then();
    }
  }

  redirectCustomLogin() {
    return
    const host = window.location.protocol + '//' + window.location.host;
    let currentUrl = window.location.href.split('?')[0].replace(host, '');
    if (!currentUrl.includes('/auth/forgot-password')
      && !currentUrl.includes('/auth/reset-forgot-password'))
      this.router.navigate(['/auth/login']).then();
  }


  redirectToLogin() {
    localStorage.removeItem(VtSSOService.requestParamTicketKey);
    const host = window.location.protocol + '//' + window.location.host;
    let currentUrl = window.location.href.split('?')[0].replace(host, '');
    currentUrl = '/auth/login';
    localStorage.setItem(VtSSOService.callbackUrlKey, currentUrl);
    let href = window.location.href;
    if (window.location.pathname !== '/') {
      href = href.replaceAll(window.location.pathname, '/');
    }
    // window.location.href = environment.vtSso.loginDomain + '/sso/login?service=' + href;
    window.location.href = environment.vtSso.loginDomain + '/auth/login?service=' + href;
  }

  redirectToLogout() {
    localStorage.removeItem(VtSSOService.requestParamTicketKey);
    const host = window.location.protocol + '//' + window.location.host;
    //  || window.location.href.split('?')[0].replace(host, '');
    const currentUrl = '/auth/login'
    localStorage.setItem(VtSSOService.callbackUrlKey, currentUrl);
    let href = host + currentUrl;

    if (window.location.pathname !== '/') {
      href = href.replaceAll(window.location.pathname, '/');
    }
    window.location.href = environment.vtSso.loginDomain + '/sso/logout?service=' + href;
  }
}
